/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDirections = createReactComponent("outline", "directions", "IconDirections", [["path", { "d": "M12 21v-4", "key": "svg-0" }], ["path", { "d": "M12 13v-4", "key": "svg-1" }], ["path", { "d": "M12 5v-2", "key": "svg-2" }], ["path", { "d": "M10 21h4", "key": "svg-3" }], ["path", { "d": "M8 5v4h11l2 -2l-2 -2z", "key": "svg-4" }], ["path", { "d": "M14 13v4h-8l-2 -2l2 -2z", "key": "svg-5" }]]);

export { IconDirections as default };
//# sourceMappingURL=IconDirections.mjs.map
